import React from "react";

const TestComponent = () => {
  return (
    <div className="min-h-screen bg-green-500 flex items-center justify-center">
      <div className="text-center text-white">
        <h1 className="text-6xl font-bold mb-4">✅ TEST COMPONENT WORKS!</h1>
        <p className="text-2xl">React app is running correctly</p>
        <p className="text-lg mt-4">Timestamp: {new Date().toLocaleString()}</p>
      </div>
    </div>
  );
};

export default TestComponent;
